import { baseTemplateParams } from '../shared/baseParams.js'
import { TERRANEA_EDITORIAL_DEFAULTS } from '../shared/editorialEventDefaults.js'

export const defaultTemplateParams = {
  ...baseTemplateParams,
  ...TERRANEA_EDITORIAL_DEFAULTS,
  richtextFields: {
    ...baseTemplateParams.richtextFields,
    ...TERRANEA_EDITORIAL_DEFAULTS.richtextFields
  },
  selectedTemplate: 'editorialEvent',
  shellTemplateKey: 'editorialEvent'
}

export default defaultTemplateParams
